/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Execute_Detail7Inputs */

const en_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate, validate and publish in batches.`)
};

const ar_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ وتحقق وانشر على دفعات.`)
};

const bn_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাচে তৈরি, যাচাই আর প্রকাশ করুন।`)
};

const de_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Chargen generieren, validieren und veröffentlichen.`)
};

const es_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar, validar y publicar por lotes.`)
};

const fr_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez, validez et publiez par lots.`)
};

const pt_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar, validar e publicar por lotes.`)
};

const zh_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分批生成、验证、发布。`)
};

const tr_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partiler halinde üret, doğrula, yayınla.`)
};

const ru_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерируйте, валидируйте и публикуйте батчами.`)
};

const pl_svc_programmatic_seo_execute_detail7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj, waliduj i publikuj paczkami.`)
};

/**
* | output |
* | --- |
* | "Generate, validate and publish in batches." |
*
* @param {Svc_Programmatic_Seo_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_execute_detail7 = /** @type {((inputs?: Svc_Programmatic_Seo_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "de") return de_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "es") return es_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_execute_detail7(inputs)
	return en_svc_programmatic_seo_execute_detail7(inputs)
});
export { svc_programmatic_seo_execute_detail7 as "svc_programmatic-seo_EXECUTE_detail" }